import React from 'react';
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { IngredientType } from '../types/IngredientType';
import { CookIngredientChip } from './IngredientChip';
import commonStyles from 'config/commonStyles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        chipContainer: {
            maxWidth: '50%',
            width: '100%',
        },
    })
);

export function CookIngredientsList(type: IngredientType, ingredients: string[]) {
    const classes = useStyles();

    return (
        <div className={clsx(classes.mTop10, classes.mBot10)}>
            <Grid container spacing={1}>
                {ingredients.map((item) => (
                    <Grid
                        item
                        xs={6}
                        className={classes.chipContainer}
                        key={`$${item}-${Math.random().toString(36).substring(2, 9)}`}
                    >
                        <CookIngredientChip type={type} text={item} />
                    </Grid>
                ))}
            </Grid>
        </div>
    );
}
